import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  TemplateRef,
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { ButtonModule, IconModule } from '@pinup-teams/common';
import { TranslateModule } from '@ngx-translate/core';

import { MessageDatePipe } from '../../../../pipes/date.pipe';

@Component({
  standalone: true,
  selector: 'chat-message',
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconModule,
    TranslateModule,
    ButtonModule,
    MessageDatePipe,
    NgClass,
    NgTemplateOutlet,
  ],
})
export class ChatMessageComponent {
  textContent = contentChild<TemplateRef<any>>('textContent');
  nameContent = contentChild<TemplateRef<any>>('nameContent');
}
